import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { take, takeUntil, tap, withLatestFrom } from 'rxjs/operators';
import { LABEL_PARAMS } from '../label-list/label-list.component';
import { LabelService } from '../label.service';
import { Label } from '../model/label';
import { ELabelType } from 'src/app/models/label';

@Component({
    selector: 'app-add-label-modal',
    templateUrl: './add-label-modal.component.html',
    styleUrls: ['./add-label-modal.component.scss'],
})
export class AddLabelModalComponent implements OnInit, OnDestroy {
    labels$ = new BehaviorSubject([]);
    isLoading$ = new BehaviorSubject(true);
    editLabel$ = new Subject();
    labelListUpdated$ = new Subject<any>();
    close$ = new Subject<void>();
    assignedLabelsMap$ = new BehaviorSubject({});
    newLabelTitle = new FormControl('');

    destroy$ = new Subject<void>();

    constructor(private labelService: LabelService, @Inject(LABEL_PARAMS) public params: any) {}

    ngOnInit(): void {
        this.fetchData();
        this.params.singleLabelUpdated$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.fetchData();
        });
    }

    fetchData() {
        this.labelService
            .findAllLabels(this.params.type)
            .pipe(tap(() => this.isLoading$.next(false)))
            .subscribe((items) => {
                this.labels$.next(items);
                this.processAssignedLabelsMap(this.params.assignedLabels);
            });
    }

    emitOpenEditDialog(labelData: Partial<Label>) {
        this.editLabel$.next(labelData);
    }

    processAssignedLabelsMap(assignedLabels) {
        const assignedIds = assignedLabels.map(({ id }) => id);
        this.labels$.subscribe((allLabels) => {
            const allLabelIds = allLabels.map(({ id }) => id);
            const resultMap = {};
            for (const id of assignedIds) {
                if (allLabelIds.includes(id)) {
                    resultMap[id] = true;
                }
            }
            this.assignedLabelsMap$.next(resultMap);
        });
    }
    unassignLabel(labelId: string) {
        this.labelService.unassignLabel(labelId, this.params.orderId).subscribe((data) => {
            this.processAssignedLabelsMap(data);
            this.labelListUpdated$.next(data);
        });
    }
    assignLabel(labelId: string, type = ELabelType.OrderBoard) {
        this.labelService.assignLabel(labelId, this.params.orderId, type).subscribe((data) => {
            this.processAssignedLabelsMap(data);
            this.labelListUpdated$.next(data);
        });
    }
    assignLabelToOrder(label, type = ELabelType.OrderBoard) {
        const labelId = label.id;
        this.assignedLabelsMap$.pipe(take(1)).subscribe((items) => {
            const assigned = Object.keys(items).indexOf(labelId) !== -1;
            if (assigned) {
                this.unassignLabel(labelId);
            } else {
                this.assignLabel(labelId, type);
            }
        });
    }
    ngOnDestroy(): void {
        this.destroy$.next();
    }
}
